import FormattedMessage from 'I18n/components/FormattedMessage';
import * as React from 'react';
import UIButton from 'UIComponents/button/UIButton';
import FlowDoctorHandlerContext from 'flow-doctor-lib/context/FlowDoctorHandlerContext';
import { getValueFromLocalStorage, setValueInLocalStorage } from 'flow-doctor-lib/utils/localStorage';
import useInstanceCount from 'flow-doctor-lib/hooks/useInstanceCount';
import { H4 } from 'UIComponents/elements/headings';
import { Popover } from 'foundations-components/transitional/components/Popover';
import { jsx as _jsx } from "react/jsx-runtime";
const INSTANCE_KEY = 'ENROLLMENT_CHECKS_BUTTON';
const EnrollmentChecksButton = ({
  timelineItem
}) => {
  const {
    onRunEnrollmentChecks
  } = React.useContext(FlowDoctorHandlerContext);
  const [showShepherd, setShowShepherd] = React.useState(false);
  const instanceCountAtMount = useInstanceCount({
    instanceKey: INSTANCE_KEY
  });
  React.useEffect(() => {
    if (onRunEnrollmentChecks && !getValueFromLocalStorage('has-seen-enrollment-checks-shepherd') && instanceCountAtMount === 1) {
      setShowShepherd(true);
    }
  }, [onRunEnrollmentChecks, instanceCountAtMount]);
  if (!onRunEnrollmentChecks) {
    // Determines if we render the button. We want to avoid doing so in customer-facing cases or in the did-enroll diagnosis
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Popover, {
      use: "shepherd",
      inlineSize: "350px",
      open: showShepherd,
      showCloseButton: true,
      onOpenChange: evt => {
        setValueInLocalStorage('has-seen-enrollment-checks-shepherd', 'true');
        setShowShepherd(evt.target.value);
      },
      placement: "right",
      autoPlacement: false,
      closeOnOutsideClick: false,
      content: {
        header: /*#__PURE__*/_jsx(H4, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.objectLifecycle.enrollmentChecksShepherd.title"
          })
        }),
        body: /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "flow-doctor-lib.flows.objectLifecycle.enrollmentChecksShepherd.description"
          })
        })
      },
      children: /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary-light",
        size: "xs",
        onClick: () => onRunEnrollmentChecks(timelineItem),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.objectLifecycle.runEnrollmentChecks"
        })
      })
    })
  });
};
export default EnrollmentChecksButton;